import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCT_LINKS, CONTACT_PHONE, CONTACT_PHONE_DISPLAY, CONTACT_EMAIL, CONTACT_ADDRESS } from '../../constants';
import '../../styles/Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-column">
        <h2>QUICK LINKS</h2>
        <ul>
          <li><a href="https://www.cormix.com/" target="_blank" rel="noopener noreferrer">About Cormix</a></li>
          <li><Link to="/certification">Certification</Link></li>
          <li><Link to="/products">Our Products</Link></li>
          <li><Link to="/services">Our Services</Link></li>
          <li><Link to="/services/foundation-waterproofing#few-case-studies">Our Projects</Link></li>
        </ul>
      </div>
      <div className="footer-column">
        <h2>DOCUMENT DOWNLOAD</h2>
        <ul>
          {Object.entries(PRODUCT_LINKS).map(([name, url]) => (
            <li key={name}>
              <a href={url} target="_blank" rel="noopener noreferrer">{name}</a>
            </li>
          ))}
        </ul>
      </div>
      <div className="footer-column contact-column">
        <h2>CONTACT US</h2>
        <ul className="contact-details">
          <li>Galaxy Specialised Waterproofing CO. LLC</li>
          <li>
            Phone &amp; WhatsApp:{' '}
            <a href={`https://wa.me/${CONTACT_PHONE}`} target="_blank" rel="noopener noreferrer" className="contact-link">
              {CONTACT_PHONE_DISPLAY}
            </a>
          </li>
          <li>Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>
          <li>{CONTACT_ADDRESS}</li>
        </ul>
      </div>
    </div>
    <div className="copyright">
      &copy; {new Date().getFullYear()} Galaxy Specialised Waterproofing CO. LLC. All rights reserved.
    </div>
  </footer>
);

export default Footer;
